<template>
  <v-dialog
    :value="open"
    @input="$emit('on-close')"
    max-width="850"
    scrollable
    transition="fade"
    :persistent="saving"
  >
    <v-card color="white" class="trip-wizard">
      
      <v-card-title class="primary white--text text-xs-center" style="position: relative;">
        <v-btn
          absolute
          small
          fab
          top
          right
          flat
          color="white"
          style="top: 10px;"
          :disabled="saving"
          @click="$emit('on-close')"
        ><v-icon>fas fa-times</v-icon></v-btn>
        <h3 style="margin: 0 auto;">Review Your Trip</h3>
      </v-card-title>
      <v-card-text v-if="loading">
        <div class="spinner">
          <div class="double-bounce1"></div>
          <div class="double-bounce2"></div>
        </div>
      </v-card-text>
      <v-card-text v-else class="pa-0">
        <v-stepper v-model="itemPage">
          <v-stepper-items>
            <v-stepper-content
              v-for="(item, itemIndex) in reviewItems"
              :key="'item-' + item.id + '-step-' + itemIndex"
              :step="itemIndex"
            >
              <v-container fluid grid-list-lg>
                <v-layout v-if="item.id == 'tripReview'" class="text-xs-center" row wrap>
                  <v-flex xs12 class="text-xs-center">
                    <h2>Please let us know anything else about your items or overall trip experience</h2>
                  </v-flex>
                  <v-flex xs12>
                    <v-textarea
                      outline
                      label="Additional Feedback"
                      v-model="tripFeedback"
                    ></v-textarea>
                  </v-flex> 
                  <v-flex class="text-xs-center">
                    <v-btn color="primary" @click="submit()">Submit</v-btn>
                  </v-flex>
                </v-layout>
                <v-layout v-else row justify-center align-center :wrap="$vuetify.breakpoint.smAndDown">

                  <v-flex xs12 sm12 style="max-width: 200px;">
                    <inventory-item :item="item" ignore-availability></inventory-item>
                  </v-flex>
                  <v-flex class="text-xs-center">
                    <v-stepper v-model="itemQuestionPage" class="elevation-0">
                      <v-stepper-content step="howManyTimes">
                        <h2>How many times did you wear this item?</h2>
                        <v-layout justify-center class="mt-3">
                          <v-flex
                            v-for="n in itemsWornList"
                            :key="'worn-' + item.id + '-' + n"
                            shrink
                          >
                            <v-hover>
                              <div 
                                slot-scope="{ hover }"
                                class="circle-container"
                                :class="{'hovering':hover, 'selected':( n == currentPageSelected )}"
                                @click="toggleSelected(n)"
                              > 
                                <div class="selected-background">
                                  
                                </div>
                                <div class="hover-background"></div>
                                <div class="text-container">{{ n }}</div>
                              </div>
                            </v-hover>
                          </v-flex>
                        </v-layout>
                      </v-stepper-content>

                      <v-stepper-content step="howMuchDidYouLike">
                        <h2>How much did you like this item?</h2>
                        <v-layout justify-center class="mt-3" column align-center>
                          <v-flex
                            v-for="n in itemLikeList"
                            :key="'like-' + item.id + '-' + n"
                          >
                            <v-hover>
                              <div 
                                slot-scope="{ hover }"
                                class="rectangle-container"
                                :class="{'hovering':hover, 'selected':( n == currentPageSelected )}"
                                @click="toggleSelected(n)"
                              > 
                                <div class="selected-background">
                                  
                                </div>
                                <div class="hover-background"></div>
                                <div class="text-container">{{ n }}</div>
                              </div>
                            </v-hover>
                          </v-flex>
                        </v-layout>
                      </v-stepper-content>

                      <v-stepper-content step="whyDidntYouWear">
                        <h2>Why Didn't You Wear It?</h2>
                        <v-layout justify-center class="mt-3" column align-center>
                          <v-flex
                            v-for="n in itemDidntWear"
                            :key="'notwear-' + item.id + '-' + n"
                          >
                            <v-hover>
                              <div 
                                slot-scope="{ hover }"
                                class="rectangle-container"
                                :class="{'hovering':hover, 'selected':( n == currentPageSelected )}"
                                @click="toggleSelected(n)"
                              > 
                                <div class="selected-background">
                                  
                                </div>
                                <div class="hover-background"></div>
                                <div class="text-container">{{ n }}</div>
                              </div>
                            </v-hover>
                          </v-flex>
                        </v-layout>
                      </v-stepper-content>

                      <v-stepper-content step="whichAreaDidntFit">
                        <h2>Which areas didn't fit you well?</h2>
                        <v-layout justify-center class="mt-3" column align-center>
                          <v-flex
                            v-for="n in areasDidntFitWell"
                            :key="'notfitwell-' + item.id + '-' + n"
                          >
                            <v-hover>
                              <div 
                                slot-scope="{ hover }"
                                class="rectangle-container"
                                :class="{'hovering':hover, 'selected':( areaSelected(n) )}"
                                @click="toggleArea(n)"
                              > 
                                <div class="selected-background">
                                  
                                </div>
                                <div class="hover-background"></div>
                                <div class="text-container">{{ n }}</div>
                              </div>
                            </v-hover>
                          </v-flex>
                        </v-layout>
                        <div class="mt-3 text-xs-center">
                          <v-btn color="primary" :disabled="!canContinue" @click="nextPage()">Continue</v-btn>
                        </div>
                      </v-stepper-content>
                    </v-stepper>

                    
                    <div class="mt-3 text-xs-center">
                      <a @click.stop="nextItem(true)">Skip Item</a>
                    </div>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-card-text>
      <v-card-actions class="primary white--text">
        <v-spacer></v-spacer>
        
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import InventoryItem from '@/components/helpers/InventoryItem';

export default {
  props: {
    open: Boolean,
    tripId: {
      type: [String,Number],
      require: true,
    }
  },
  components: {
    'inventory-item': InventoryItem
  },
  name: 'ReviewDialog',
  data () {
    return {
      saving: false,
      loading: true,

      trip: {},
      reviewItems: [],

      itemPage: '0',
      itemQuestionPage: 'howManyTimes',
      currentPageSelected: null,
      tripFeedback: null,

      reviewPage: 1,

      itemsWornList: ['0','1','2','3','4+'],
      itemLikeList: ['I Heart It','Not So Bad','I Don\'t Like It'],
      itemDidntWear: ['Didn\'t Fit', 'I Don\'t Like It', 'Didn\'t Look Good On Me', 'Didn\'t Arrive On Time', 'Worn-Out', 'Other'],
      areasDidntFitWell: ['Overall','Arms/Shoulders','Chest','Waist','Hips','Length']

    }
  },
  mounted: function() {
  },
  watch: {
    open: function(newVal, oldVal) {
      if(newVal) this.getDataFromApi();
    }
  },
  computed: {
    cdn: function() {
      return this.$root.cdn;
    },
    user: function() {
      return this.$store.getters.user;
    },

    canContinue: function() {

      if(this.reviewPage == 1) {
        if(!this.currentPageSelected && this.currentPageSelected !== '0' && this.currentPageSelected !== 0) return false;
      }
      return true;

    }
  },
  methods: {
    getDataFromApi: function() {
      this.$http.get('trips/' + this.tripId + '?expand=tripReview,order,order.orderInventory,order.orderInventory.itemReview,order.inventory,order.inventory.variations')
        .then(response => {
          this.trip = response.data;
          let items = [];
          for(let i = 0; i < this.trip.order.orderInventory.length; i++) {
            let orderInv = this.trip.order.orderInventory[i];
            let item = {};
            for(let i2 = 0; i2 < this.trip.order.inventory.length; i2++) {
              if(this.trip.order.inventory[i2].id == orderInv.inventory_id) item = this.trip.order.inventory[i2];
            }
            item.recommended = orderInv.variation_id;
            item.selected = orderInv.variation_id;
            item.review = {
              worn: (orderInv.itemReview && orderInv.itemReview.meta ? orderInv.itemReview.meta.worn + '' : null)
            }

            items.push(item);
          }
          items.push({id: 'tripReview'});
          this.reviewItems = items;
          this.itemPage = '0';
          this.itemQuestionPage = 'howManyTimes';
          this.currentPageSelected = null;
          this.loading = false;
        })
        .catch(error => {
          this.$swal.fire('Error', 'There was an error loading the review panel. Please try again. If this problem continues please contact support');
          this.$emit('on-close');
        })
        .finally(() => {

        });

    },
    submit: function() {
      let allSkipped = true;

      for(let i = 0; i < this.reviewItems.length; i++) {
        let item = this.reviewItems[i];
        if(item.id == 'tripReview') continue;
        if(item.review.skip != 1) allSkipped = false;
      }

      let data = {
        user_id:        this.user.id,
        trip_id:        this.trip.id,
        type:           'TRIP'
      }

      if(allSkipped && (!this.tripFeedback || this.tripFeedback == null || this.tripFeedback.trim() == '')) {
        data.skipped = 1;
      } else {
        data.feedback = this.tripFeedback;
      }

      this.$http.post('reviews', data)
        .then(response => {
          this.$swal.fire('Thank You!', 'Your feedback is appreciated');
          this.$emit('on-close');
          this.$emit('on-review-complete');
        })
        .catch(error => {

        })
        .finally(() => {

        });

    },

    submitItem: function(item) {
      let data = {
        user_id:        this.user.id,
        trip_id:        this.trip.id,
        inventory_id:   item.id,
        variation_id:   item.recommended,
        type:           'INVENTORY'
      };
      if(item.review.skip == 1) {
        data.skipped = 1;
      } else {
        data.setMeta = item.review;
      }

      this.$http.post('reviews', data)
        .then(response => {

        })
        .catch(error => {

        })
        .finally(() => {

        });
    },

    toggleSelected: function(selected) {
      let set = null;
      if(selected != this.currentPageSelected) set = selected;
      this.currentPageSelected = selected;
      this.nextPage();
    },
    toggleArea: function(area) {
      let tempArr = [];
      if(this.currentPageSelected != null) {
        tempArr = this.currentPageSelected.split(',');
      }
      let index = tempArr.indexOf(area);
      if(index >= 0) {
        tempArr.splice(index, 1);
      } else {
        tempArr.push(area);
      }
      this.currentPageSelected = tempArr.join(',');
    },
    areaSelected: function(area) {
      if(this.currentPageSelected == null) return false;
      if(this.currentPageSelected.split(',').indexOf(area) >= 0) return true;
      return false;
    },

    nextPage: function() {
      if(this.itemQuestionPage == 'howManyTimes') {
        this.reviewItems[this.itemPage].review.worn = this.currentPageSelected;
        if(this.reviewItems[this.itemPage].review.worn == 0) {
          this.itemQuestionPage = 'whyDidntYouWear';
        } else {
          this.itemQuestionPage = 'howMuchDidYouLike';
        }
        this.currentPageSelected = null;
      } else if(this.itemQuestionPage == 'howMuchDidYouLike') {
        this.reviewItems[this.itemPage].review.like = this.currentPageSelected;
        this.nextItem();   
      } else if(this.itemQuestionPage == 'whyDidntYouWear') {
        this.reviewItems[this.itemPage].review.why_not_wear = this.currentPageSelected;
        if(this.reviewItems[this.itemPage].review.why_not_wear == 'Didn\'t Fit') {  
          this.itemQuestionPage = 'whichAreaDidntFit';
          this.currentPageSelected = null;
        } else {
          this.nextItem();
        }
      } else if(this.itemQuestionPage == 'whichAreaDidntFit') {
        this.reviewItems[this.itemPage].review.areas_not_fit = this.currentPageSelected;
        this.nextItem();
      }
    },

    nextItem: function(skip = false) {
      if(skip) this.reviewItems[this.itemPage].review.skip = 1;

      this.submitItem(this.reviewItems[this.itemPage]);

      this.itemPage = parseInt(this.itemPage) + 1;

      this.itemQuestionPage = 'howManyTimes';
      this.currentPageSelected = null;
    }
  }
}
</script>